import React from "react"

import "./content.module.scss"
import CodeBlock from "../components/code-block"

export default function Content({ content }) {
    return (
        <section>
            {content.map(block => {
                if (block.blockType === "RichTextBlock") {
                    return <section key={block.id} dangerouslySetInnerHTML={{ __html: block.value }} />
                } else if (block.blockType === "CodeBlock") {
                    return <section key={block.id}><CodeBlock block={block} /></section>
                }
            })}
        </section>
    )
}
